import React, { useState } from "react";

export default function Contact() {
    const [form, setForm] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
        consent: true,
    });

    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setStatus("sending");

        try {
            const response = await fetch(
                "https://formspree.io/f/mdenrwbb",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({
                        name: form.name,
                        phone: form.phone,
                        email: form.email,
                        message: form.message,
                        consent: form.consent ? "Yes" : "No",
                    }),
                }
            );

            if (response.ok) {
                setStatus("success");

                setForm({
                    name: "",
                    phone: "",
                    email: "",
                    message: "",
                    consent: true,
                });
            } else {
                setStatus("error");
            }
        } catch (error) {
            console.error("Form submission error:", error);
            setStatus("error");
        }
    };

    return (
        <section
            className="border-b border-border bg-foreground px-6 py-20 text-background"
            id="contact"
        >
            <div className="mx-auto max-w-screen-md">
                <div className="border border-background/10 bg-background p-8 text-foreground md:p-12">

                    <h2 className="mb-4 text-center text-4xl font-bold tracking-tight">
                        Book Your Call
                    </h2>

                    <p className="mx-auto mb-10 max-w-md text-center text-muted-foreground">
                        Please fill out the following details and we&rsquo;ll reach
                        out with the right opportunities for you.
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-6">

                        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

                            {/* Name */}
                            <div>
                                <label
                                    htmlFor="name"
                                    className="mb-2 block font-bold text-[11px] uppercase tracking-widest text-muted-foreground"
                                >
                                    Name
                                </label>

                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    placeholder="Enter your name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="w-full border border-border bg-surface px-4 py-3 text-sm outline-none focus:border-accent"
                                    required
                                />
                            </div>

                            {/* Phone */}
                            <div>
                                <label
                                    htmlFor="phone"
                                    className="mb-2 block font-bold text-[11px] uppercase tracking-widest text-muted-foreground"
                                >
                                    Phone
                                </label>

                                <input
                                    id="phone"
                                    name="phone"
                                    type="tel"
                                    inputMode="numeric"
                                    placeholder="Enter your mobile number"
                                    value={form.phone}
                                    onChange={handleChange}
                                    onKeyDown={(e) => {
                                        if (
                                            !/[0-9]/.test(e.key) &&
                                            ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ].includes(e.key)
                                        ) {
                                            e.preventDefault();
                                        }
                                    }}
                                    className="w-full border border-border bg-surface px-4 py-3 text-sm outline-none focus:border-accent"
                                    required
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div>
                            <label
                                htmlFor="email"
                                className="mb-2 block font-bold text-[11px] uppercase tracking-widest text-muted-foreground"
                            >
                                Email Address
                            </label>

                            <input
                                id="email"
                                name="email"
                                type="email"
                                placeholder="Enter your email"
                                value={form.email}
                                onChange={handleChange}
                                className="w-full border border-border bg-surface px-4 py-3 text-sm outline-none focus:border-accent"
                                required
                            />
                        </div>

                        {/* Message */}
                        <div>
                            <label
                                htmlFor="message"
                                className="mb-2 block font-bold text-[11px] uppercase tracking-widest text-muted-foreground"
                            >
                                Message
                            </label>

                            <textarea
                                id="message"
                                name="message"
                                rows="4"
                                placeholder="Enter your enquiry"
                                value={form.message}
                                onChange={(e) => {
                                    const words = e.target.value.trim().split(/\s+/).filter(Boolean);

                                    if (words.length <= 100) {
                                        handleChange(e);
                                    }
                                }}
                                className="w-full resize-none border border-border bg-surface px-4 py-3 text-sm outline-none focus:border-accent"
                                required
                            />

                            <p className="mt-2 text-right font-mono text-[10px] text-muted-foreground">
                                {form.message.trim()
                                    ? form.message.trim().split(/\s+/).filter(Boolean).length
                                    : 0}{" "}
                                / 100 words
                            </p>
                        </div>

                        {/* Consent */}
                        <label className="flex items-start gap-3 text-xs text-muted-foreground">
                            <input
                                type="checkbox"
                                name="consent"
                                checked={form.consent}
                                onChange={handleChange}
                                className="mt-0.5 h-4 w-4 accent-accent"
                            />

                            <span>
                                I authorise VELOX Industrial &amp; its representatives
                                to contact me with updates and notifications via
                                Email, Call, SMS/RCS, WhatsApp, regardless of
                                DND/NDNC.
                            </span>
                        </label>

                        {/* Submit */}
                        <button
                            type="submit"
                            disabled={status === "sending"}
                            className="w-full bg-accent px-6 py-4 font-mono text-sm font-bold uppercase tracking-widest text-accent-foreground transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
                        >
                            {status === "sending"
                                ? "Sending..."
                                : "Submit"}
                        </button>

                        {/* Success */}
                        {status === "success" && (
                            <div className="border border-green-500/30 bg-green-500/10 p-4 text-center text-sm text-green-600">
                                Thank you! Your enquiry has been submitted
                                successfully. We&rsquo;ll get back to you soon.
                            </div>
                        )}

                        {/* Error */}
                        {status === "error" && (
                            <div className="border border-red-500/30 bg-red-500/10 p-4 text-center text-sm text-red-600">
                                Something went wrong while submitting your
                                enquiry. Please try again.
                            </div>
                        )}

                    </form>
                </div>
            </div>
        </section>
    );
}